import _regeneratorRuntime from "D:\\SaigonIT\\2.SourceCode\\WebRactGUISolution\\WebRactGUISolution\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "D:\\SaigonIT\\2.SourceCode\\WebRactGUISolution\\WebRactGUISolution\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
// @license © 2020 Google LLC. Licensed under the Apache License, Version 2.0.
import e from "./supported.mjs";
var s = e ? "chooseFileSystemEntries" === e ? import("./fs-access-legacy/file-save.mjs") : import("./fs-access/file-save.mjs") : import("./legacy/file-save.mjs");
export function fileSave() {
  return _fileSave.apply(this, arguments);
}

function _fileSave() {
  _fileSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$s;

    var _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return s;

          case 2:
            return _context.abrupt("return", (_yield$s = _context.sent).default.apply(_yield$s, _args));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fileSave.apply(this, arguments);
}